import { atom } from 'jotai';
import type { Language } from '@entities/language/model/types';

export const languageInitialState: Language = {
  locale: 'en',
  displayName: 'English',
  direction: 'ltr',
};

export const languageAtom = atom<Language>(languageInitialState);
